<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <div class="row">
        <HeaderComp currentPage="chapter"></HeaderComp>

        <GhanaChapterContent class="text-black" />

        <FooterComp></FooterComp>
      </div>
    </ion-content>
  </ion-page>
</template>
<script>
import HeaderComp from '@/components/layouts/HeaderComp'
import FooterComp from '@/components/layouts/FooterComp'
import GhanaChapterContent from '@/views/content/chapters/GhanaChapterContent'
export default {
  components: { GhanaChapterContent, FooterComp, HeaderComp },

  data() {
    return {}
  },
}
</script>
